var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "course-goods-detail"
  }, [_c('a-modal', {
    attrs: {
      "title": "微信扫码购买",
      "footer": null,
      "maskClosable": false,
      "width": 250
    },
    model: {
      value: _vm.buyQrcodeShow,
      callback: function callback($$v) {
        _vm.buyQrcodeShow = $$v;
      },
      expression: "buyQrcodeShow"
    }
  }, [_c('qrcode-vue', {
    attrs: {
      "value": _vm.getBuyLink(),
      "size": 200,
      "level": "H"
    }
  })], 1), _c('a-row', {
    staticClass: "intoduction",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('a-col', {
    staticClass: "cover",
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.activityInfo.activityCover,
      "alt": ""
    }
  })]), _c('a-col', {
    staticClass: "buy",
    attrs: {
      "span": 15
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.activityInfo.activityName))]), _c('p', [_vm._v(_vm._s(_vm.activityInfo.activityDesc))]), _c('div', {
    staticClass: "price"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("价格：")]), _c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_c('span', {
    staticClass: "origianl-pirce"
  }, [_vm._v("￥ " + _vm._s(_vm.activityInfo.originalPrice / 100))])])], 1), _vm.activityInfo.price != null ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("优惠价：")]), _c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_c('span', {
    staticClass: "sale-price"
  }, [_vm._v("￥ " + _vm._s(_vm.activityInfo.price / 100))])])], 1) : _vm._e()], 1), _c('a-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.toBuy
    }
  }, [_vm._v(_vm._s(_vm.activityInfo.price == 0 ? '领取' : '购买'))])], 1)], 1), _c('div', {
    staticClass: "content-wrap"
  }, [_c('a-divider', [_vm._v("商品信息")]), _vm.activityInfo.contentType == 1 ? _c('div', {
    staticClass: "content-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.activityInfo.landingImgPc,
      "alt": ""
    }
  })]) : _vm._e(), _vm.activityInfo.contentType == 2 ? _c('div', {
    staticClass: "content-html",
    domProps: {
      "innerHTML": _vm._s(_vm.activityInfo.landingHtmlPc)
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };